export default class LoginCredential {
  constructor () {
    this.email = ''
    this.password = ''
    this.orgid = null
  }
}
